/* global bocAmchart4 */
/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} event object containing the all the data
 * @returns {void}
 */
bocAmchart4.postProcessValetCategories = function (event) {
    try {
        return bocAmchart4.doPostProcessValetCategories(event);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        throw (error);
    }
};

/**
 * Produces and returns an array of data based on the valet data for the data with categories,
 * rather than time data. function detects if data contains dimensions and chooses different preprocessing.
 *
 * @param {object} event object containing the all the data
 * @returns {void}
 */
bocAmchart4.doPostProcessValetCategories = function (event) {

    var data = event.target.data;

    var chart = event.target.component;

    // If the data is compressed, uncompress it
    data = bocAmchart4.decodeData(data, chart);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running postProcessValetCategories, input data:",
            data
        );
    }


    if (chart.bocSettings.args.hasOwnProperty("datacallback")) {
        if (typeof window[chart.bocSettings.args.datacallback] === "function") {
            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.groupCollapsed(chart.bocSettings.id + " running data callback "
                    + chart.bocSettings.args.datacallback);
                // eslint-disable-next-line no-console
                console.log(window[chart.bocSettings.args.datacallback].toString());
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            window[chart.bocSettings.args.datacallback](chart, data);
        } else {
            // eslint-disable-next-line no-console
            console.log(chart.bocSettings.id + " did not find data callback function "
                + chart.bocSettings.args.datacallback);
        }
    }


    var dataProcessor = new bocAmchart4.DataProcessor(chart, data, 'category');

    var dimension = dataProcessor.getDimension();
    var processedData = [];


    if (chart.bocSettings.args.hasOwnProperty("transpose")
        && dimension === 'd' && !dataProcessor.doLabelsContainUnderscores()) {
        // if labels do not contain underscores, and we are trying to transpose, then it must be yield curve type
        // chart and so, try to extract / create series from dates
        dataProcessor.parseSeriesTermsFromLabels();
        processedData = dataProcessor.createTransposedSeriesAndGetData();
    } else if (dimension === 'd') {
        dataProcessor.parseSeriesTermsFromLabels();
        if (chart.bocSettings.type !== 'pie') {
            dataProcessor.addGraphsFromShortcode();
        }
        processedData = dataProcessor.getSeriesAndObservationsByCategoryFromDate();
        if (chart.bocSettings.args.hasOwnProperty("categoryorderfromgroup")) {
            processedData = dataProcessor.orderCategoriesFromDateByGroupOrder(processedData);
        }
    } else {
        dataProcessor.addGraphsFromShortcode();
        dataProcessor.addGraphsFromValetSeries();
        processedData = dataProcessor.getObservationsByCategory();
    }
    dataProcessor.addGraphsToChart();

    if (chart.bocSettings.args.hasOwnProperty("multilevel")) {
        var xAxisType = 'date';
        if (chart.bocSettings.args.hasOwnProperty("xaxistype")) {
            xAxisType = chart.bocSettings.args.xaxistype;
        }

        var yAxisType = "number";
        if (chart.bocSettings.args.hasOwnProperty("yaxistype")) {
            yAxisType = chart.bocSettings.args.yaxistype;
        }
        var vertical = yAxisType === 'text' && xAxisType === 'number';
        bocAmchart4.generateMultiLevelAxis(chart, processedData, vertical);
    }

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (typeof window[chart.bocSettings.args.callback] === "function") {
            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
                // eslint-disable-next-line no-console
                console.log(window[chart.bocSettings.args.callback].toString());
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            window[chart.bocSettings.args.callback](chart, processedData);
        } else {
            // eslint-disable-next-line no-console
            console.log(chart.bocSettings.id + " did not find data callback function " + chart.bocSettings.args.callback);
        }
    }

    bocAmchart4.getChartTitlesFromGroup(data, chart);
    bocAmchart4.processTitles(chart, processedData);
    bocAmchart4.processNotes(chart, processedData);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Data after postProcessValetCategories:",
            processedData
        );
    }

    new bocAmchart4.InteractiveProcessor(chart, processedData);
    if (typeof chart.bocSettings.interactiveConfig !== 'undefined') {
        processedData = chart.data;
    }

    if (chart.bocSettings.type === 'map') {
        chart.series.values[0].data = processedData;
    } else {
        event.target.data = processedData;
    }
    bocAmchart4.generatePrintCopy(chart);
};
